import React from 'react';
import { Form, Radio } from 'antd';
import { I18n } from '@aws-amplify/core';

import { WorkloadComparisonProps } from './types';
import { OptionRow, PairContainer, RadioOptionContainer, MiddleOptionText, OptionBox, OptionText } from './styles';

export function WorkloadComparison({ comparison, saveAnswer }: WorkloadComparisonProps): React.ReactElement {
	const FIELD_NAME = `question_${comparison.questionId}`;
	const form = Form.useFormInstance();
	const SELECTED_VALUE = form.getFieldValue(FIELD_NAME);

	function handleSelect(value: string): void {
		form.setFieldValue(FIELD_NAME, value);

		const option = value === comparison.option1.value ? comparison.option1 : comparison.option2;
		if (saveAnswer) {
			saveAnswer(comparison.questionId, option.id);
		}
	}

	return (
		<PairContainer key={`${comparison.option1.id}_${comparison.option2.id}`}>
			<Form.Item noStyle shouldUpdate style={{ marginBottom: '0px' }}>
				<Form.Item name={FIELD_NAME} noStyle>
					<Radio.Group>
						<span style={{ display: 'none' }}>
							<Radio value={comparison.option1.value} />
							<Radio value={comparison.option2.value} />
						</span>
					</Radio.Group>
				</Form.Item>

				<OptionRow>
					<RadioOptionContainer>
						<OptionBox
							isSelected={SELECTED_VALUE === comparison.option1.value}
							onClick={() => handleSelect(comparison.option1.value)}
						>
							<OptionText isSelected={SELECTED_VALUE === comparison.option1.value}>
								{I18n.get(comparison.option1.name)}
							</OptionText>
						</OptionBox>
					</RadioOptionContainer>

					<MiddleOptionText>
						<span>{I18n.get('or')}</span>
					</MiddleOptionText>

					<RadioOptionContainer>
						<OptionBox
							isSelected={SELECTED_VALUE === comparison.option2.value}
							onClick={() => handleSelect(comparison.option2.value)}
						>
							<OptionText isSelected={SELECTED_VALUE === comparison.option2.value}>
								{I18n.get(comparison.option2.name)}
							</OptionText>
						</OptionBox>
					</RadioOptionContainer>
				</OptionRow>
			</Form.Item>
		</PairContainer>
	);
}
